import { Surah } from '@/types/surah';

export const SURAHS: Surah[] = [
  {
    id: 1,
    name: 'ٱلْفَاتِحَةِ',
    englishName: 'Al-Faatiha',
    revelationType: 'Meccan',
    ayahCount: 7,
  },
  {
    id: 2,
    name: 'البَقَرَةِ',
    englishName: 'Al-Baqara',
    revelationType: 'Medinan',
    ayahCount: 286,
  },
  {
    id: 3,
    name: 'آلِ عِمۡرَانَ',
    englishName: 'Aal-i-Imraan',
    revelationType: 'Medinan',
    ayahCount: 200,
  },
  {
    id: 4,
    name: 'النِّسَاءِ',
    englishName: 'An-Nisaa',
    revelationType: 'Medinan',
    ayahCount: 176,
  },
  {
    id: 5,
    name: 'المَائـِدَةِ',
    englishName: 'Al-Maaida',
    revelationType: 'Medinan',
    ayahCount: 120,
  },
  {
    id: 6,
    name: 'الأَنۡعَامِ',
    englishName: "Al-An'aam",
    revelationType: 'Meccan',
    ayahCount: 165,
  },
  {
    id: 7,
    name: 'الأَعۡرَافِ',
    englishName: "Al-A'raaf",
    revelationType: 'Meccan',
    ayahCount: 206,
  },
  {
    id: 8,
    name: 'الأَنفَالِ',
    englishName: 'Al-Anfaal',
    revelationType: 'Medinan',
    ayahCount: 75,
  },
  {
    id: 9,
    name: 'التَّوۡبَةِ',
    englishName: 'At-Tawba',
    revelationType: 'Medinan',
    ayahCount: 129,
  },
  {
    id: 10,
    name: 'يُونُسَ',
    englishName: 'Yunus',
    revelationType: 'Meccan',
    ayahCount: 109,
  },
  {
    id: 11,
    name: 'هُودٍ',
    englishName: 'Hud',
    revelationType: 'Meccan',
    ayahCount: 123,
  },
  {
    id: 12,
    name: 'يُوسُفَ',
    englishName: 'Joseph',
    revelationType: 'Meccan',
    ayahCount: 111,
  },
  {
    id: 13,
    name: 'الرَّعۡدِ',
    englishName: "Ar-Ra'd",
    revelationType: 'Medinan',
    ayahCount: 43,
  },
  {
    id: 14,
    name: 'إِبۡرَاهِيمَ',
    englishName: 'Abraham',
    revelationType: 'Meccan',
    ayahCount: 52,
  },
  {
    id: 15,
    name: 'الحِجۡرِ',
    englishName: 'Al-Hijr',
    revelationType: 'Meccan',
    ayahCount: 99,
  },
  {
    id: 16,
    name: 'النَّحۡلِ',
    englishName: 'An-Nahl',
    revelationType: 'Meccan',
    ayahCount: 128,
  },
  {
    id: 17,
    name: 'الإِسۡرَاءِ',
    englishName: 'Al-Israa',
    revelationType: 'Meccan',
    ayahCount: 111,
  },
  {
    id: 18,
    name: 'الكَهۡفِ',
    englishName: 'Al-Kahf',
    revelationType: 'Meccan',
    ayahCount: 110,
  },
  {
    id: 19,
    name: 'مَرۡيَمَ',
    englishName: 'Mary',
    revelationType: 'Meccan',
    ayahCount: 98,
  },
  {
    id: 20,
    name: 'طه',
    englishName: 'Taa-Haa',
    revelationType: 'Meccan',
    ayahCount: 135,
  },
  {
    id: 21,
    name: 'الأَنبِيَاءِ',
    englishName: 'Al-Anbiyaa',
    revelationType: 'Meccan',
    ayahCount: 112,
  },
  {
    id: 22,
    name: 'الحَجِّ',
    englishName: 'Al-Hajj',
    revelationType: 'Medinan',
    ayahCount: 78,
  },
  {
    id: 23,
    name: 'المُؤۡمِنُونَ',
    englishName: 'Al-Muminoon',
    revelationType: 'Meccan',
    ayahCount: 118,
  },
  {
    id: 24,
    name: 'النُّورِ',
    englishName: 'An-Noor',
    revelationType: 'Medinan',
    ayahCount: 64,
  },
  {
    id: 25,
    name: 'الفُرۡقَانِ',
    englishName: 'Al-Furqaan',
    revelationType: 'Meccan',
    ayahCount: 77,
  },
  {
    id: 26,
    name: 'الشُّعَرَاءِ',
    englishName: "Ash-Shu'araa",
    revelationType: 'Meccan',
    ayahCount: 227,
  },
  {
    id: 27,
    name: 'النَّمۡلِ',
    englishName: 'An-Naml',
    revelationType: 'Meccan',
    ayahCount: 93,
  },
  {
    id: 28,
    name: 'القَصَصِ',
    englishName: 'Al-Qasas',
    revelationType: 'Meccan',
    ayahCount: 88,
  },
  {
    id: 29,
    name: 'العَنكَبُوتِ',
    englishName: 'Al-Ankaboot',
    revelationType: 'Meccan',
    ayahCount: 69,
  },
  {
    id: 30,
    name: 'الرُّومِ',
    englishName: 'Ar-Room',
    revelationType: 'Meccan',
    ayahCount: 60,
  },
  {
    id: 31,
    name: 'لُقۡمَانَ',
    englishName: 'Luqman',
    revelationType: 'Meccan',
    ayahCount: 34,
  },
  {
    id: 32,
    name: 'السَّجۡدَةِ',
    englishName: 'As-Sajda',
    revelationType: 'Meccan',
    ayahCount: 30,
  },
  {
    id: 33,
    name: 'الأَحۡزَابِ',
    englishName: 'Al-Ahzaab',
    revelationType: 'Medinan',
    ayahCount: 73,
  },
  {
    id: 34,
    name: 'سَبَإٍ',
    englishName: 'Sheba',
    revelationType: 'Meccan',
    ayahCount: 54,
  },
  {
    id: 35,
    name: 'فَاطِرٍ',
    englishName: 'Faatir',
    revelationType: 'Meccan',
    ayahCount: 45,
  },
  {
    id: 36,
    name: 'يسٓ',
    englishName: 'Yaseen',
    revelationType: 'Meccan',
    ayahCount: 83,
  },
  {
    id: 37,
    name: 'الصَّافَّاتِ',
    englishName: 'As-Saaffaat',
    revelationType: 'Meccan',
    ayahCount: 182,
  },
  {
    id: 38,
    name: 'صٓ',
    englishName: 'Saad',
    revelationType: 'Meccan',
    ayahCount: 88,
  },
  {
    id: 39,
    name: 'الزُّمَرِ',
    englishName: 'Az-Zumar',
    revelationType: 'Meccan',
    ayahCount: 75,
  },
  {
    id: 40,
    name: 'غَافِرٍ',
    englishName: 'Ghafir',
    revelationType: 'Meccan',
    ayahCount: 85,
  },
  {
    id: 41,
    name: 'فُصِّلَتۡ',
    englishName: 'Fussilat',
    revelationType: 'Meccan',
    ayahCount: 54,
  },
  {
    id: 42,
    name: 'الشُّورَىٰ',
    englishName: 'Ash-Shura',
    revelationType: 'Meccan',
    ayahCount: 53,
  },
  {
    id: 43,
    name: 'الزُّخۡرُفِ',
    englishName: 'Az-Zukhruf',
    revelationType: 'Meccan',
    ayahCount: 89,
  },
  {
    id: 44,
    name: 'الدُّخَانِ',
    englishName: 'Ad-Dukhaan',
    revelationType: 'Meccan',
    ayahCount: 59,
  },
  {
    id: 45,
    name: 'الجَاثِيَةِ',
    englishName: 'Al-Jaathiya',
    revelationType: 'Meccan',
    ayahCount: 37,
  },
  {
    id: 46,
    name: 'الأَحۡقَافِ',
    englishName: 'Al-Ahqaf',
    revelationType: 'Meccan',
    ayahCount: 35,
  },
  {
    id: 47,
    name: 'مُحَمَّدٍ',
    englishName: 'Muhammad',
    revelationType: 'Medinan',
    ayahCount: 38,
  },
  {
    id: 48,
    name: 'الفَتۡحِ',
    englishName: 'Al-Fath',
    revelationType: 'Medinan',
    ayahCount: 29,
  },
  {
    id: 49,
    name: 'الحُجُرَاتِ',
    englishName: 'Al-Hujuraat',
    revelationType: 'Medinan',
    ayahCount: 18,
  },
  {
    id: 50,
    name: 'قٓ',
    englishName: 'Qaaf',
    revelationType: 'Meccan',
    ayahCount: 45,
  },
  {
    id: 51,
    name: 'الذَّارِيَاتِ',
    englishName: 'Adh-Dhaariyat',
    revelationType: 'Meccan',
    ayahCount: 60,
  },
  {
    id: 52,
    name: 'الطُّورِ',
    englishName: 'At-Tur',
    revelationType: 'Meccan',
    ayahCount: 49,
  },
  {
    id: 53,
    name: 'النَّجۡمِ',
    englishName: 'An-Najm',
    revelationType: 'Meccan',
    ayahCount: 62,
  },
  {
    id: 54,
    name: 'القَمَرِ',
    englishName: 'Al-Qamar',
    revelationType: 'Meccan',
    ayahCount: 55,
  },
  {
    id: 55,
    name: 'الرَّحۡمَٰن',
    englishName: 'Ar-Rahmaan',
    revelationType: 'Medinan',
    ayahCount: 78,
  },
  {
    id: 56,
    name: 'الوَاقِعَةِ',
    englishName: 'Al-Waaqia',
    revelationType: 'Meccan',
    ayahCount: 96,
  },
  {
    id: 57,
    name: 'الحَدِيدِ',
    englishName: 'Al-Hadid',
    revelationType: 'Medinan',
    ayahCount: 29,
  },
  {
    id: 58,
    name: 'المُجَادلَةِ',
    englishName: 'Al-Mujaadila',
    revelationType: 'Medinan',
    ayahCount: 22,
  },
  {
    id: 59,
    name: 'الحَشۡرِ',
    englishName: 'Al-Hashr',
    revelationType: 'Medinan',
    ayahCount: 24,
  },
  {
    id: 60,
    name: 'المُمۡتَحنَةِ',
    englishName: 'Al-Mumtahana',
    revelationType: 'Medinan',
    ayahCount: 13,
  },
  {
    id: 61,
    name: 'الصَّفِّ',
    englishName: 'As-Saff',
    revelationType: 'Medinan',
    ayahCount: 14,
  },
  {
    id: 62,
    name: 'الجُمُعَةِ',
    englishName: "Al-Jumu'a",
    revelationType: 'Medinan',
    ayahCount: 11,
  },
  {
    id: 63,
    name: 'المُنَافِقُونَ',
    englishName: 'Al-Munaafiqoon',
    revelationType: 'Medinan',
    ayahCount: 11,
  },
  {
    id: 64,
    name: 'التَّغَابُنِ',
    englishName: 'At-Taghaabun',
    revelationType: 'Medinan',
    ayahCount: 18,
  },
  {
    id: 65,
    name: 'الطَّلَاقِ',
    englishName: 'At-Talaaq',
    revelationType: 'Medinan',
    ayahCount: 12,
  },
  {
    id: 66,
    name: 'التَّحۡرِيمِ',
    englishName: 'At-Tahrim',
    revelationType: 'Medinan',
    ayahCount: 12,
  },
  {
    id: 67,
    name: 'المُلۡكِ',
    englishName: 'Al-Mulk',
    revelationType: 'Meccan',
    ayahCount: 30,
  },
  {
    id: 68,
    name: 'القَلَمِ',
    englishName: 'Al-Qalam',
    revelationType: 'Meccan',
    ayahCount: 52,
  },
  {
    id: 69,
    name: 'الحَاقَّةِ',
    englishName: 'Al-Haaqqa',
    revelationType: 'Meccan',
    ayahCount: 52,
  },
  {
    id: 70,
    name: 'المَعَارِجِ',
    englishName: "Al-Ma'aarij",
    revelationType: 'Meccan',
    ayahCount: 44,
  },
  {
    id: 71,
    name: 'نُوحٍ',
    englishName: 'Nooh',
    revelationType: 'Meccan',
    ayahCount: 28,
  },
  {
    id: 72,
    name: 'الجِنِّ',
    englishName: 'Al-Jinn',
    revelationType: 'Meccan',
    ayahCount: 28,
  },
  {
    id: 73,
    name: 'المُزَّمِّلِ',
    englishName: 'Al-Muzzammil',
    revelationType: 'Meccan',
    ayahCount: 20,
  },
  {
    id: 74,
    name: 'المُدَّثِّرِ',
    englishName: 'Al-Muddaththir',
    revelationType: 'Meccan',
    ayahCount: 56,
  },
  {
    id: 75,
    name: 'القِيَامَةِ',
    englishName: 'Al-Qiyaama',
    revelationType: 'Meccan',
    ayahCount: 40,
  },
  {
    id: 76,
    name: 'الإِنسَانِ',
    englishName: 'Al-Insaan',
    revelationType: 'Medinan',
    ayahCount: 31,
  },
  {
    id: 77,
    name: 'المُرۡسَلَاتِ',
    englishName: 'Al-Mursalaat',
    revelationType: 'Meccan',
    ayahCount: 50,
  },
  {
    id: 78,
    name: 'النَّبَإِ',
    englishName: 'An-Naba',
    revelationType: 'Meccan',
    ayahCount: 40,
  },
  {
    id: 79,
    name: 'النَّازِعَاتِ',
    englishName: "An-Naazi'aat",
    revelationType: 'Meccan',
    ayahCount: 46,
  },
  {
    id: 80,
    name: 'عَبَسَ',
    englishName: 'Abasa',
    revelationType: 'Meccan',
    ayahCount: 42,
  },
  {
    id: 81,
    name: 'التَّكۡوِيرِ',
    englishName: 'At-Takwir',
    revelationType: 'Meccan',
    ayahCount: 29,
  },
  {
    id: 82,
    name: 'الانفِطَارِ',
    englishName: 'Al-Infitaar',
    revelationType: 'Meccan',
    ayahCount: 19,
  },
  {
    id: 83,
    name: 'المُطَفِّفِينَ',
    englishName: 'Al-Mutaffifin',
    revelationType: 'Meccan',
    ayahCount: 36,
  },
  {
    id: 84,
    name: 'الانشِقَاقِ',
    englishName: 'Al-Inshiqaaq',
    revelationType: 'Meccan',
    ayahCount: 25,
  },
  {
    id: 85,
    name: 'البُرُوجِ',
    englishName: 'Al-Burooj',
    revelationType: 'Meccan',
    ayahCount: 22,
  },
  {
    id: 86,
    name: 'الطَّارِقِ',
    englishName: 'At-Taariq',
    revelationType: 'Meccan',
    ayahCount: 17,
  },
  {
    id: 87,
    name: 'الأَعۡلَىٰ',
    englishName: "Al-A'laa",
    revelationType: 'Meccan',
    ayahCount: 19,
  },
  {
    id: 88,
    name: 'الغَاشِيَةِ',
    englishName: 'Al-Ghaashiya',
    revelationType: 'Meccan',
    ayahCount: 26,
  },
  {
    id: 89,
    name: 'الفَجۡرِ',
    englishName: 'Al-Fajr',
    revelationType: 'Meccan',
    ayahCount: 30,
  },
  {
    id: 90,
    name: 'البَلَدِ',
    englishName: 'Al-Balad',
    revelationType: 'Meccan',
    ayahCount: 20,
  },
  {
    id: 91,
    name: 'الشَّمۡسِ',
    englishName: 'Ash-Shams',
    revelationType: 'Meccan',
    ayahCount: 15,
  },
  {
    id: 92,
    name: 'اللَّيۡلِ',
    englishName: 'Al-Lail',
    revelationType: 'Meccan',
    ayahCount: 21,
  },
  {
    id: 93,
    name: 'الضُّحَىٰ',
    englishName: 'Ad-Dhuhaa',
    revelationType: 'Meccan',
    ayahCount: 11,
  },
  {
    id: 94,
    name: 'الشَّرۡحِ',
    englishName: 'Ash-Sharh',
    revelationType: 'Meccan',
    ayahCount: 8,
  },
  {
    id: 95,
    name: 'التِّينِ',
    englishName: 'At-Tin',
    revelationType: 'Meccan',
    ayahCount: 8,
  },
  {
    id: 96,
    name: 'العَلَقِ',
    englishName: 'Al-Alaq',
    revelationType: 'Meccan',
    ayahCount: 19,
  },
  {
    id: 97,
    name: 'القَدۡرِ',
    englishName: 'Al-Qadr',
    revelationType: 'Meccan',
    ayahCount: 5,
  },
  {
    id: 98,
    name: 'البَيِّنَةِ',
    englishName: 'Al-Bayyina',
    revelationType: 'Medinan',
    ayahCount: 8,
  },
  {
    id: 99,
    name: 'الزَّلۡزَلَةِ',
    englishName: 'Az-Zalzala',
    revelationType: 'Medinan',
    ayahCount: 8,
  },
  {
    id: 100,
    name: 'العَادِيَاتِ',
    englishName: 'Al-Aadiyaat',
    revelationType: 'Meccan',
    ayahCount: 11,
  },
  {
    id: 101,
    name: 'القَارِعَةِ',
    englishName: "Al-Qaari'a",
    revelationType: 'Meccan',
    ayahCount: 11,
  },
  {
    id: 102,
    name: 'التَّكَاثُرِ',
    englishName: 'At-Takaathur',
    revelationType: 'Meccan',
    ayahCount: 8,
  },
  {
    id: 103,
    name: 'العَصۡرِ',
    englishName: 'Al-Asr',
    revelationType: 'Meccan',
    ayahCount: 3,
  },
  {
    id: 104,
    name: 'الهُمَزَةِ',
    englishName: 'Al-Humaza',
    revelationType: 'Meccan',
    ayahCount: 9,
  },
  {
    id: 105,
    name: 'الفِيلِ',
    englishName: 'Al-Fil',
    revelationType: 'Meccan',
    ayahCount: 5,
  },
  {
    id: 106,
    name: 'قُرَيۡشٍ',
    englishName: 'Quraish',
    revelationType: 'Meccan',
    ayahCount: 4,
  },
  {
    id: 107,
    name: 'المَاعُونِ',
    englishName: "Al-Maa'un",
    revelationType: 'Meccan',
    ayahCount: 7,
  },
  {
    id: 108,
    name: 'الكَوۡثَرِ',
    englishName: 'Al-Kawthar',
    revelationType: 'Meccan',
    ayahCount: 3,
  },
  {
    id: 109,
    name: 'الكَافِرُونَ',
    englishName: 'Al-Kaafiroon',
    revelationType: 'Meccan',
    ayahCount: 6,
  },
  {
    id: 110,
    name: 'النَّصۡرِ',
    englishName: 'An-Nasr',
    revelationType: 'Medinan',
    ayahCount: 3,
  },
  {
    id: 111,
    name: 'المَسَدِ',
    englishName: 'Al-Masad',
    revelationType: 'Meccan',
    ayahCount: 5,
  },
  {
    id: 112,
    name: 'الإِخۡلَاصِ',
    englishName: 'Al-Ikhlaas',
    revelationType: 'Meccan',
    ayahCount: 4,
  },
  {
    id: 113,
    name: 'الفَلَقِ',
    englishName: 'Al-Falaq',
    revelationType: 'Meccan',
    ayahCount: 5,
  },
  {
    id: 114,
    name: 'النَّاسِ',
    englishName: 'Mankind',
    revelationType: 'Meccan',
    ayahCount: 6,
  },
];
